import React, { useState, useEffect } from "react";
import styles from "./style.module.css";

export default function ImageModal({ isOpen, onClose, images }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (isOpen) setCurrentIndex(0); // reset to first image when opened
    }, [isOpen]);

    if (!isOpen) return null;

    const prevImage = () => {
        setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const nextImage = () => {
        setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                {/* Close button */}
                <button onClick={onClose} className={styles.closeBtn}>
                    ✕
                </button>

                <h2 className={styles.title}>Image Gallery</h2>

                {/* Image slider */}
                <div className={styles.slider}>
                    <button className={styles.navBtn} onClick={prevImage}>
                        ‹
                    </button>

                    <img
                        src={images[currentIndex]}
                        alt={`img-${currentIndex}`}
                        className={styles.mainImage}
                    />

                    <button className={styles.navBtn} onClick={nextImage}>
                        ›
                    </button>
                </div>

                {/* Thumbnails */}
                <div className={styles.thumbnails}>
                    {images.map((src, idx) => (
                        <img
                            key={idx}
                            src={src}
                            alt={`thumb-${idx}`}
                            className={`${styles.thumbnail} ${
                                idx === currentIndex
                                    ? styles.activeThumbnail
                                    : ""
                            }`}
                            onClick={() => setCurrentIndex(idx)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
